import { useTranslations } from '@vocab/react';
import {
  Alert,
  Box,
  Stack,
  Text,
  List,
  TextLinkButton,
} from 'braid-design-system';
import React from 'react';

import { CAREER_HISTORY, EDUCATION } from 'src/components/Router';
import { Link } from 'src/components/Router/Link';
import { READ } from 'src/consts';
import type { Mode } from 'src/types';

import translations from './.vocab';

interface ParsedDataAlertProps {
  resumeName: string;
  rolesFound: number;
  qualificationsFound: number;
  onClose: () => void;
}

export const ParsedDataAlert = ({
  resumeName,
  rolesFound,
  qualificationsFound,
  onClose,
}: ParsedDataAlertProps) => {
  const { t } = useTranslations(translations);
  const linkProps = {
    mode: READ as Mode,
    component: TextLinkButton,
    analytics: { actionName: 'resume_parsing_new_info_pressed' },
    params: { allowScroll: true },
  };

  return (
    <Alert tone="promote" onClose={onClose} closeLabel={t('Dismiss')}>
      <Box display="flex" width="full" justifyContent="spaceBetween">
        <Box marginRight="medium">
          <Stack space="small">
            <Text>
              {t('We found new information in resume to add to your Profile', {
                resumeName,
              })}
            </Text>
            <List>
              {rolesFound > 0 && (
                <Text>
                  <Link
                    to={CAREER_HISTORY}
                    data={{ automation: 'parsed-roles-found' }}
                    {...linkProps}
                  >
                    {t('n new roles', { rolesFound })}
                  </Link>
                </Text>
              )}
              {qualificationsFound > 0 && (
                <Text>
                  <Link
                    to={EDUCATION}
                    data={{ automation: 'parsed-qualifications-found' }}
                    {...linkProps}
                  >
                    {t('n new qualifications', { qualificationsFound })}
                  </Link>
                </Text>
              )}
            </List>
          </Stack>
        </Box>
      </Box>
    </Alert>
  );
};
